import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/manga";
import { SectionTitle } from "./SectionTitle";

export default function HotRank() {
  const items = mangaList.filter((m) => m.category === "hot");

  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionTitle
          eyebrow="TRENDING"
          title="热门新番 · 热度榜"
          desc="热门新番同步追，全网讨论度最高的作品都在这里。"
          to="/hot"
          linkText="查看完整榜单"
        />

        <div className="mt-8 grid grid-cols-1 gap-3 md:grid-cols-2">
          {items.map((m, i) => (
            <Link
              key={m.id}
              to={`/article/${m.id}`}
              className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-100/60 p-3.5 transition hover:border-primary-300 hover:bg-primary-100/50"
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl font-heading text-xl ${
                  i === 0
                    ? "bg-accent-500 text-background-50"
                    : i === 1
                    ? "bg-primary-500 text-background-50"
                    : i === 2
                    ? "bg-secondary-500 text-background-50"
                    : "bg-background-200 text-foreground-700"
                }`}
              >
                {i + 1}
              </span>
              <div className="h-16 w-12 shrink-0 overflow-hidden rounded-lg bg-background-200">
                <img
                  src={m.cover}
                  alt={`${m.title} 热门新番`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-bold text-foreground-900 md:text-base">
                  {m.title}
                </h3>
                <div className="mt-1 flex flex-wrap gap-1">
                  {m.tags.map((t) => (
                    <span
                      key={t}
                      className="rounded-md bg-secondary-100 px-1.5 py-0.5 text-xs text-secondary-900"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
              <div className="text-right">
                <p className="flex items-center gap-1 text-sm font-bold text-accent-600">
                  <i className="ri-star-fill"></i>
                  {m.rating}
                </p>
                <p className="mt-1 text-xs text-foreground-500">{m.update}</p>
              </div>
              <i className="ri-arrow-right-s-line text-xl text-foreground-400 transition group-hover:translate-x-0.5 group-hover:text-primary-600"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}